export default {
    SET_FOOTER_TOGGLE : 'SET_FOOTER_TOGGLE',
    SET_FOOTER_HEIGHT : 'SET_FOOTER_HEIGHT',
    IS_SHOW_FOOTER : 'IS_SHOW_FOOTER',
    SET_STYLE_ID: 'SET_STYLE_ID',
    SET_INITIAL_FOOTER : 'SET_INITIAL_FOOTER',
    SET_REDIRECT_EDIT_PAGE: 'SET_REDIRECT_EDIT_PAGE',
    SET_IS_SHOW_CART_PAGE: 'SET_IS_SHOW_CART_PAGE',
};
